






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { calculateDays, Location } from "@/calc";
import { Interval, DateTime } from "luxon";
import LocationPicker, {
  NominatimResult
} from "@/components/LocationPicker.vue";

@Component({
  components: { LocationPicker }
})
export default class SunsetsApp extends Vue {
  intervals: Array<Interval>;
  DateTime: typeof DateTime;
  firstLocation: NominatimResult = {
    display_name: "Berlin, Germany",
    lat: "52.4642",
    lon: "13.3494"
  };
  secondLocation: NominatimResult = {
    display_name: "Saint Denis, Réunion, France",
    lat: "-21.098",
    lon: "55.4397"
  };

  constructor() {
    super();
    this.intervals = [];
    this.DateTime = DateTime;
  }

  @Watch("firstLocation")
  @Watch("secondLocation")
  onLocationsChanged(): void {
    if (
      !this.firstLocation ||
      !this.firstLocation.lat ||
      !this.secondLocation ||
      !this.secondLocation.lat
    ) {
      return;
    }

    const firstCoordinates: [number, number] = [
      parseFloat(this.firstLocation.lat),
      parseFloat(this.firstLocation.lon)
    ];
    const secondCoordinates: [number, number] = [
      parseFloat(this.secondLocation.lat),
      parseFloat(this.secondLocation.lon)
    ];

    this.intervals = calculateDays(firstCoordinates, secondCoordinates);
  }

  created(): void {
    this.onLocationsChanged();
  }
}
